import React from 'react'
import { useNavigate } from 'react-router-dom'
import logoImage from '../images/logo192.png'
import { useTranslation } from 'react-i18next'


export default function AboutPage() {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const goToSearchPage = () => {
        navigate('/')
    }

    return (
        <div className='about-page'>
            <div onClick={() => goToSearchPage()} className="about-header">
                <img src={logoImage} alt="Logo" className="logo" />
                <h3>Sigurica AI </h3>
            </div>

            <div className='about-body'>
                <div className='about-body-card'>
                    <h3>{t('aboutApp')}</h3>
                    <p>{t('siguricaDescription')}</p>
                    <p>{t('aiGuideText')}</p>
                    <p>{t('appDisclaimer')}</p>

                    <h4>{t('importantToKnow')}</h4>

                    <ul>
                        <li>- {t('aiDevelopmentNotice')}</li>
                        <li>- {t('aiAnalysisInfo')}</li>
                        <li>- {t('registeredUsersBenefits')}</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
